import React, { useState, useEffect } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import InputMask from "react-input-mask";
import BaseSelect from 'components/baseSelect' ;
import { Field } from 'formik';

const EducationForm = ({errors, touched, handleChange, values, element, removeEducationForm, options, empresaId = 96}) => {

    const onRemoveForm = () => removeEducationForm(element.id);
    const [isActual, setIsActual] = useState(false);

    useEffect(() => {
        if (values[`current_${element.id}`]) {
            disabledEndYear();
        }
    }, [])

    const onChangeRadio = (event) => {
        if (event.target.value == "true") {
            values[`current_${element.id}`] = true 
            disabledEndYear();
        } else {
            values[`current_${element.id}`] = false
            setIsActual(false);
        }
    }

    const disabledEndYear = () => {
        values[`until_${element.id}`] = '';
        setIsActual(true);
    }

    return (
        <>
            <Form.Group as={Col} md="3" controlId={"validationschool_" + element.id}>
                <Form.Label>Centro educativo * </Form.Label>
                <Form.Control
                    type="text"
                    name={`school_${element.id}`}
                    placeholder=""
                    value={values[`school_${element.id}`]}
                    onChange={handleChange}
                    //isValid={touched[`school_${element.id}`] && !errors[`school_${element.id}`]}
                    isInvalid={!!errors[`school_${element.id}`]}
                />
                <Form.Control.Feedback type="invalid">
                    {errors[`school_${element.id}`]}
                </Form.Control.Feedback>
            </Form.Group>

            <BaseSelect
                md={3}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                values={values}
                label={'Nivel *'}
                name={`level_${element.id}`}
                url={'EstudioNivel?$filter=empresaId eq ' + empresaId}
            />
            
            <BaseSelect
                md={3}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                values={values}
                label={'Área de estudio *'}
                name={`studyArea_${element.id}`}
                url={'EstudioArea?$filter=empresaId eq ' + empresaId}
            />

            <BaseSelect
                md={3}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                values={values}
                label={values[`current_${element.id}`] === true ? 'Horario *' : 'Horario'}
                name={`schedule_${element.id}`}
                url={'HorarioTipo?$filter=empresaId eq ' + empresaId} 
            />

            <Form.Group as={Col} md="3" controlId={"validationyearFrom_" + element.id}>
                <Form.Label>Año desde</Form.Label>
                <Form.Control
                    type="number"
                    name={`yearFrom_${element.id}`}
                    placeholder="2004"
                    value={values[`yearFrom_${element.id}`]}
                    onChange={handleChange}
                    //isValid={touched[`yearFrom_${element.id}`] && !errors[`yearFrom_${element.id}`]}
                    isInvalid={!!errors[`yearFrom_${element.id}`]}
                />
                <Form.Control.Feedback type="invalid">
                    {errors[`yearFrom_${element.id}`]}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="3" controlId={"validationuntil_" + element.id}>
                <Form.Label>{values[`current_${element.id}`] === false ? "Hasta *" : "Hasta"}</Form.Label>
                <Form.Control
                    type="number"
                    name={`until_${element.id}`}
                    placeholder="2008"
                    value={values[`until_${element.id}`]}
                    onChange={handleChange}
                    disabled={isActual}
                    //isValid={touched[`until_${element.id}`] && !errors[`until_${element.id}`]}
                    isInvalid={!!errors[`until_${element.id}`]}
                />
                <Form.Control.Feedback type="invalid">
                    {errors[`until_${element.id}`]}
                </Form.Control.Feedback>
            </Form.Group>
            
            <Form.Group as={Col} md="6" controlId={"validationtitle_" + element.id}>
                <Form.Label>Título *</Form.Label>
                <Form.Control
                    type="text"
                    name={`title_${element.id}`}
                    placeholder=""
                    value={values[`title_${element.id}`]}
                    onChange={handleChange}
                    //isValid={touched[`title_${element.id}`] && !errors[`title_${element.id}`]}
                    isInvalid={!!errors[`title_${element.id}`]}
                />
                <Form.Control.Feedback type="invalid">
                    {errors[`title_${element.id}`]}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="2" controlId={"validationcurrent_" + element.id}>
                <div>
                    <Form.Label> Actual </Form.Label>

                    <div onChange={onChangeRadio}>
                        <input type="radio" value="true" name={`current_${element.id}`}  defaultChecked={values[`current_${element.id}`]}  /> {' '}Sí
                        &nbsp;&nbsp;<input type="radio" value="false" name={`current_${element.id}`}  defaultChecked={!values[`current_${element.id}`]} />  {' '}No
                    </div>

                    {/* &nbsp;&nbsp; <Field type="radio" name={`current_${element.id}`}/>
                    {' '} {values[`current_${element.id}`] ? 'Sí' : 'No' } */}

                </div>
            </Form.Group>


            {/* <Form.Group as={Col} md="12" controlId={"validationdescription_" + element.id}>
                <Form.Label>Breve descripción</Form.Label>
                <Form.Control
                    as="textarea"
                    name={`description_${element.id}`}
                    placeholder=""
                    value={values[`description_${element.id}`]}
                    onChange={handleChange}
                    //isValid={touched[`description_${element.id}`] && !errors[`description_${element.id}`]}
                    isInvalid={!!errors[`description_${element.id}`]}
                />
                <Form.Control.Feedback type="invalid">
                    {errors[`description_${element.id}`]}
                </Form.Control.Feedback>
            </Form.Group> */}
               
            <Form.Group as={Col} md="10">
                <Button style={{float: 'right'}} onClick={onRemoveForm} variant="outline-primary"> <i className="fas fa-trash-alt"></i> </Button>
            </Form.Group>
        </>
    )
}

export default EducationForm;